import { render, staticRenderFns } from "./DashboardSidebar.vue?vue&type=template&id=ec3c0c86&"
import script from "./DashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./DashboardSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports